module.exports = __webpack_public_path__ + "static/svitolina-gray-2157cf22c9ae93d8bfdab59a714dbf74.png";